import React, { useState } from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getCategories, getReports } from '../../redux/reporting/actions';
import styles from './MainReporting.module.scss';
import ReportContent from './ReportContent/ReportContent';
import ReportingHeader from './ReportingHeader/ReportingHeader.jsx';
import Loading from '../layout/loading/Loading';

const MainReporting = ({ getCategories, getReports, loading }) => {
	const [cognosApi, setCognosApi] = useState();
	const [dashboardAPI, setDashboardAPI] = useState();
	const [reportUniqueName, setReportUniqueName] = useState();
	const [reportTitle, setReportTitle] = useState();
	const [reportDbIndex, setReportDbIndex] = useState();
	const [search, setSearch] = useState();

	useEffect(() => {
		getCategories();
		getReports();
	}, []);

	useEffect(() => {
		console.log('reportTitle', reportTitle);
	}, [reportTitle]);

	const handleSearch = (e) => {
		setSearch(e.target.value);
	};

	return (
		<>
			{loading && <Loading />}
			<div dataset='test' className={styles.main_reporting_wrapper}>
				<div className={styles.header_wrapper}>
					<ReportingHeader
						cognosApi={cognosApi}
						dashboardAPI={dashboardAPI}
						reportUniqueName={reportUniqueName}
						reportTitle={reportTitle}
						reportDbIndex={reportDbIndex}
						handleSearch={handleSearch}
					/>
				</div>
				<div className={styles.content_wrapper}>
					<ReportContent
						setCognosApi={setCognosApi}
						setDashboardAPI={setDashboardAPI}
						setReportUniqueName={setReportUniqueName}
						setReportTitle={setReportTitle}
						setReportDbIndex={setReportDbIndex}
						search={search}
						reportTitle={reportTitle}
					/>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	loading: state.reporting.loading,
});

export default connect(mapStateToProps, { getCategories, getReports })(
	MainReporting
);
